/* eslint-disable no-unused-vars */
/* eslint-disable react/jsx-no-constructed-context-values */
/* eslint-disable import/extensions */
import Image from 'next/image';
import { usePathname } from 'next/navigation';
import { useRouter } from 'next/router';
import dynamic from 'next/dynamic';
import React, { createContext, useContext, useEffect, useReducer, useState, } from 'react';
import { Nav, Navbar, Button, Col, Badge, } from 'react-bootstrap';
import { FaCartShopping, FaCar } from 'react-icons/fa6';
import { MessagesContext } from '@/pages/_app';
import Cart from '@/components/actions/cart';
import Messages from '@/components/messages';
import Toasts from '@/components/toasts';
import DropdownProfile from '@/components/menus/dropdown-profile';
import { cart, layout, messages, store, } from '@/helpers/index';
import { auth } from '@/services/auth';
import Footer from '@/components/footer';
import Loading from '@/components/loading';
import { constant } from '@/helpers/constant';
import Buttons from '@/components/buttons/group';
import SignModal from '../modals/sign';

export const CartContext = createContext(cart.init());

export default function LayoutComponent({ enableMessages, children }) {
  const FloatingWhatsApp = dynamic(() => import('react-floating-whatsapp').then((module) => module.FloatingWhatsApp));
  const pathname = usePathname();
  const router = useRouter();
  const [state, dispatch] = useReducer(cart.reduce, cart.init());
  const { stateMessages, dispatchMessages } = useContext(MessagesContext);
  const [user, setUser] = useState(auth.store.logged.get());
  const [loginShow, setLoginShow] = useState(false);
  const [showChild, setShowChild] = useState(false);

  const avatar = '/assets/images/whatsapp-profile.png';
  const chatMessage = 'Olá! Por favor, informe a placa que deseja consultar.';
  const placeholder = 'Digite sua placa aqui';

  cart.configure(dispatch);

  const handleReportRescue = () => {
    router.push('/acesse-seu-relatorio');
  };

  const handleLogin = () => {
    // if (window.location.pathname === constant.redirect.login) { return; }
    // if (window.location.pathname !== '/') {
    //   router.push(constant.redirect.login);
    //   return;
    // }
    // messages.clear();
    // setLoginShow(true);
    window.open('https://app.aboutcar.com.br', 'app');
  };

  useEffect(() => {
    setShowChild(true);
    dispatch({ type: 'LOAD', });
    store.menu.crm.remove();
  }, []);

  if (!showChild || typeof window === 'undefined') { return null; }

  return (
    <CartContext.Provider value={{ state, dispatch }}>
      <header className="site">
        <Navbar id="navbar" bg="default" expand="md" className="not-printable px-3 px-lg-4">
          <Navbar.Brand href="/" className="not-printable py-1 me-4" onClick={layout.menu.close}>
            <Image src="/assets/themes/default/images/logo.png" width="200" height="45" border="0" alt="Logomarca da AboutCar" quality={85} style={{ objectFit: 'contain' }} />
          </Navbar.Brand>
          {!user && (
            <div className="d-block d-sm-none not-printable">
              {pathname !== constant.redirect.login && (
                <Button variant="success" onClick={handleLogin} className="btn-gradient-success rounded-pill px-3 py-1 fw-bold shadow-sm">
                  Entrar
                </Button>
              )}
            </div>
          )}
          <Navbar.Toggle aria-controls="basic-navbar-nav" className="not-printable border-0 shadow-none pe-0" />
          {(user || (state && state.quantity > 0)) && (
            <Col xs={12} className="mobile-cart not-printable">
              <div className="text-center py-2">
                {state && state.quantity > 0 && (
                  <Buttons align="center" className="not-printable">
                    <Button type="button" variant="light" className="btn-cart mobile-cart rounded-pill" onClick={() => layout.cart.show()}>
                      <FaCartShopping />
                      <Badge bg="primary" className="ms-1 text-white">
                        {state.quantity}
                      </Badge>
                    </Button>
                  </Buttons>
                )}
                {user && <DropdownProfile />}
              </div>
            </Col>
          )}
          <Navbar.Collapse id="basic-navbar-nav" className="not-printable">
            <Nav className="me-auto not-printable gap-1">
              <Nav.Link href="/seminovos" onClick={layout.menu.close} active={pathname.includes('/seminovos')} className="nav-link-seminovos">
                <FaCar className="me-1" />
                Seminovos
                <span className="seminovos-badge ms-1">NOVO</span>
              </Nav.Link>
              <Nav.Link href="/consultas-e-pacotes" onClick={layout.menu.close} active={pathname === '/consultas-e-pacotes'} className="rounded-pill px-3 fw-semibold">Consultas e Pacotes</Nav.Link>
              <Nav.Link href="/parceria" onClick={layout.menu.close} active={pathname === '/parceria'} className="rounded-pill px-3 fw-semibold">Parceria</Nav.Link>
              <Nav.Link href="/blog" onClick={layout.menu.close} active={pathname?.startsWith('/blog')} className="rounded-pill px-3 fw-semibold">Blog</Nav.Link>
              <Nav.Link href="/contato" onClick={layout.menu.close} active={pathname === '/contato'} className="rounded-pill px-3 fw-semibold">Contato</Nav.Link>
              <Nav.Link href="/acesse-seu-relatorio" onClick={layout.menu.close} active={pathname === '/acesse-seu-relatorio'} className={user ? 'rounded-pill px-3 fw-semibold' : 'rounded-pill px-3 fw-semibold d-sm-none'}>Acesse seu Relatório</Nav.Link>
            </Nav>
            {state && state.quantity > 0 && (
              <Button type="button" variant="light" className="me-2 desktop-cart btn-cart not-printable rounded-pill border" onClick={() => layout.cart.show()}>
                <FaCartShopping />
                <Badge bg="primary" className="ms-1 text-white">
                  {state.quantity}
                </Badge>
              </Button>
            )}
            {user ? <div className="desktop-cart not-printable"><DropdownProfile /></div> : (
              <div className="desktop-cart not-printable d-flex align-items-center gap-2">
                {pathname !== constant.redirect.login && (
                  <Button variant="success" onClick={handleLogin} className="btn-gradient-success rounded-pill px-4 py-2 fw-bold border-0 shadow-sm">
                    Entrar
                  </Button>
                )}
                {pathname !== constant.redirect.login && (
                  <Button variant="primary" onClick={handleReportRescue} className="btn-gradient-primary rounded-pill px-3 py-2 fw-semibold border-0 shadow-sm d-none d-lg-inline-block">
                    Acesse seu Relatório
                  </Button>
                )}
              </div>
            )}
          </Navbar.Collapse>
        </Navbar>
        <Cart state={state} />
      </header>
      <main role="main" id="main">
        {enableMessages && <Messages items={stateMessages.messages} clear={messages.clear} />}
        {children}
        <Footer />
      </main>
      <Loading />
      {loginShow && <SignModal setUser={setUser} setShow={setLoginShow} />}
      <Toasts items={stateMessages.messages} clear={messages.clear} />
      <FloatingWhatsApp avatar={avatar} phoneNumber="553190612941" accountName="AboutCar" statusMessage="Online" chatMessage={chatMessage} placeholder={placeholder} allowEsc allowClickAway />
    </CartContext.Provider>
  );
}
